import * as types from "../constants";
import ActionRequest from "../../../utils/requests/actionRequest";
import LibraryV2Api from "../../../models/LibraryV2Api";

export function loadLibraryGetMissingMetadata() {
  let action = new ActionRequest(
    LibraryV2Api.loadLibraryGetMissingMetadata,
    loadLibraryGetMissingMetadataInit,
    loadLibraryGetMissingMetadataSuccess,
    loadLibraryGetMissingMetadataFailure
  );
  return action.run({
    routeParameters: {},
    actionParameters: {},
  });
}

function loadLibraryGetMissingMetadataSuccess(librayImportData, params) {
  return {
    type: types.LIBRARY_GET_MISSING_METADATA_SUCCESS,
    data: librayImportData,
  };
}

function loadLibraryGetMissingMetadataFailure(error) {
  return {
    type: types.LIBRARY_GET_MISSING_METADATA_FAILURE,
    notification: {
      level: "error",
      label: "[action:librayImport>loadLibraryGetMissingMetadata]",
      message: "Impossible de récupérer la liste des librayImport",
      system_message: error.message,
    },
  };
}

function loadLibraryGetMissingMetadataInit(params) {
  return { type: types.LIBRARY_GET_MISSING_METADATA_INIT };
}
